'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _stripDiacritics = require('../../utils/stripDiacritics');

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterOptions(options, pfilterValue, pexcludeOptions, props) {
  var _this = this;

  var filterValue = pfilterValue;
  if ((typeof filterValue === 'undefined' ? 'undefined' : _typeof(filterValue)) === 'object' && filterValue[props.labelKey]) {
    filterValue = filterValue[props.labelKey] || filterValue[props.valueKey];
  }
  if (props.ignoreAccents) {
    filterValue = (0, _stripDiacritics2.default)(filterValue);
  }

  if (props.ignoreCase) {
    filterValue = filterValue.toLowerCase();
  }
  var excludeOptions = pexcludeOptions;
  if (excludeOptions) {
    excludeOptions = excludeOptions.map(function (i) {
      return i[props.valueKey];
    });
  }

  return options.filter(function (option) {

    if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) {
      return false;
    }

    if (props.filterOption) {
      return props.filterOption.call(_this, option, filterValue);
    }

    if (!filterValue) {
      return true;
    }

    var valueTest = String(option[props.valueKey]);
    var labelTest = String(option[props.labelKey]);
    if (props.ignoreAccents) {
      if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
      if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
    }
    if (props.ignoreCase) {
      if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
      if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
    }

    if (props.matchPos === 'start') {
      return props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue;
    } else {
      return props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
    }
  });
}

exports.default = filterOptions;